import * as React from 'react';
import { clsx } from 'clsx';
import { UIText1 } from '@cian/ui-kit';

import { ISuggestionTitleItem } from '../../../types';

import styles from './styles.module.css';

export const SuggestionTitleItem = React.forwardRef<
  HTMLDivElement,
  ISuggestionTitleItem<unknown> & { variant: 'desktop' | 'mobile' }
>((props, iconRef) => {
  return (
    <li
      className={clsx(styles['item'], styles[props.variant])}
      role="option"
      tabIndex={-1}
      data-testid="suggesttion-title-item"
    >
      {props.leftIcon && (
        <div ref={iconRef} className={styles['left-icon']}>
          {props.leftIcon}
        </div>
      )}
      <div className={clsx(styles['name'], styles[props.variant])}>
        <UIText1 display="inline" fontWeight="700">
          {props.title}
        </UIText1>
      </div>
    </li>
  );
});

SuggestionTitleItem.displayName = 'SuggestionItem';
